import { useRef } from "react";
import { useForm } from "react-hook-form";
import { useAppSelector } from "~/hooks/appSelector";
import { ComponentRequest } from "~/models/Commons ";
import { useSaveComponentsMutation } from "~/services/vm/Components";
import { selectProvider } from "~/store/feature/Provider";

export const UseVmComponentsForm = (
  onCloseModal: () => void,
  refetch: () => void,
  onSuccess?: (title: string, message: string, response: any) => void,
  onError?: (title: string, message: string) => void,
) => {
  const { cloudProviderName } = useAppSelector(selectProvider);
  const [saveComponents, { isLoading }] = useSaveComponentsMutation();

  const isSubmittingRef = useRef(false);

  const {
    formState: { errors },
    handleSubmit,
    control,
    reset,
    setValue,
  } = useForm<ComponentRequest>({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      typeId: undefined,
      name: "",
      description: "",
      content: "",
    },
  });

  const submitForm = async (data: ComponentRequest, typeId: number) => {
    // prevent double submit using ref and api loading state
    if (isSubmittingRef.current || isLoading) return;

    isSubmittingRef.current = true;

    try {
      const payload: ComponentRequest = {
        ...data,
        typeId,
      };

      const response = await saveComponents(payload).unwrap();

      if (response?.success) {
        onSuccess?.(
          "Operation completed successfully",
          response?.message,
          response,
        );
      } else {
        throw new Error("Save operation failed");
      }
    } catch (error: any) {
      onError?.(
        `${error?.data?.title} (${error?.data?.status})`,
        error?.data?.detail,
      );
      onCloseModal();
    } finally {
      isSubmittingRef.current = false;
      refetch();
      onCloseModal();
    }
  };

  return {
    handleSubmit,
    control,
    errors,
    submitForm,
    cloudProviderName,
    reset,
    setValue,
    isLoading,
    onSuccess,
    onError,
  };
};
